import React, { useState } from 'react';
import {ReactComponent as Logo} from '../../assets/images/ugcan-logo.svg';
import axios from 'axios';
import {Icon} from 'react-icons-kit';
import {eyeOff} from 'react-icons-kit/feather/eyeOff';
import {eye} from 'react-icons-kit/feather/eye';
import ResendActivationLink from './ResendActivation';
import { useEmail } from '../../hooks/useEmail';
import RegistrationStatus from './RegistrationStatus';

const CandidateRegistration = ({closeModal, email}) => {
  console.log('CandidateRegistration props:', { closeModal, email })
  console.log('closeModal type:', typeof closeModal)
  
  // Handle case where closeModal is not provided (when used as a route)
  const handleClose = () => {
    if (typeof closeModal === 'function') {
      closeModal()
    } else {
      // If no closeModal provided, navigate back or to home
      window.history.back()
    }
  }
  
  const [form, setForm] = useState({ username: '', email: email, password: '' });
  const [error, setError] = useState('');
  const [status, setStatus] = useState('');
  const [type, setType] = useState('');
  const [icon, setIcon] = useState(eyeOff);
  
  // Email service hook
  const { sendWelcomeEmail } = useEmail();
  
  const buttonClass = `m-2 p-2 h-10 w-fit 
                      bg-transparent text-primary-900 hover:text-white hover:bg-primary-900 
                      border-2 rounded-lg 
                      text-base font-bold tracking-widest normal-case items-center
                      rounded-full shadow-md transition`
  const fieldClass = "w-full bg-tertiary-600 m-1 p-2 text-sm font-nunito placeholder:text-gray-500 rounded"

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleToggle = () => {
    if (type==='password'){
       setIcon(eye);
       setType('text')
    } else {
       setIcon(eyeOff)
       setType('password')
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    
    // Simple email format check (optional)
    const isEmailValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email);
  
    // Password strength rules
    const isPasswordValid = /^(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&_])[A-Za-z\d@$!%*?&_]{8,}$/.test(form.password);
  
    if (!form.email || !form.password) {
      setError("All fields are required.");
      return;
    }
  
    if (!isEmailValid) {
      setError("Please enter a valid email address.");
      return;
    }
  
    if (!isPasswordValid) {
      setError(
        "Password must be at least 8 characters long, contain an uppercase letter, a number, and a special character."
      );
      return;
    }
  
    try {

      
      const response = await axios.post(`${process.env.REACT_APP_AUTH_URL}/auth/users/`, form, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: undefined // explicitly remove auth header
        }
      });
      console.log(response)
      if (response.status === 201) {
        // Send welcome email using Zoho API
        try {
          await sendWelcomeEmail(form.email, form.username || 'New User');
          console.log('✅ Welcome email sent successfully');
        } catch (emailError) {
          console.warn('⚠️ Welcome email failed to send:', emailError);
          // Don't fail registration if email fails
        }
        
        setError("🎉 Registration successful! A confirmation email has been sent to your email address. Please check your inbox and click the link to activate your account.");
        setStatus('Registered')
      }
    } catch (err) {
      console.log(err);
      setStatus('Error')
      if (err.response && err.response.data && err.response.data.password) {
              console.log(err.response.data.password)
              const errorData = err.response.data.password;
              const errorMessages = Object.values(errorData).flat().slice(-1)[0]; // Get the last line from the error message Object.
              console.log(errorMessages)
              setError(errorMessages);
      } else if (err.request && err.request.responseText) {
        console.log(err.request.responseText.split(":")[1])
        const errorData = err.request.responseText;
        setError(errorData);
      }
      else {
        setError(err.message);
      }
    }
  };

  const handleCancel = () => {
    console.log('handleCancel')
    handleClose()
  }

  const handleCloseModal = (e) => {
    e.preventDefault()
    e.stopPropagation()
    console.log('handleCloseModal')
    handleClose()
  }
  console.log(status)
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="modal-content w-full max-w-sm p-6 bg-primary-100 white rounded-lg shadow-lg space-y-4 relative">
          <div className="w-full max-w-sm p-6 rounded-lg shadow-lg space-y-4 bg-tertiary-600 relative">
            {/* Close button */}
            <button
              onClick={handleCloseModal}
              className={`${buttonClass} absolute top-2 right-2 w-8 h-8 flex items-center justify-center z-20`}
              aria-label="Close"
              type="button"
            >
              <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          <div className="flex justify-center items-center h-full"><Logo/></div>
            <div className="text-left bg-gradient-to-br from-white to-primary-200 border border-blue-100 p-5 rounded-xl shadow-sm space-y-3">
                <h3 className="text-2xl font-bold text-blue-800">🎉 You are Invited!</h3>
                <p className="text-gray-700 text-base leading-relaxed">
                  Got ideas? Help shape the future of College Avenue.
                </p>
                
                <div className="bg-yellow-100 text-yellow-800 px-4 py-2 rounded-lg text-base font-semibold w-fit shadow-inner">
                  🎁 First 100 students get a full year FREE!
                </div>
            </div>
          
          <form onSubmit={handleRegister}  autoComplete="off" className="w-full text-center">
            <div className="flex flex-col text-center justify-center">
              <input
                type="email"
                id="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Enter your Email"
                className={`${fieldClass}`}
                required
                autoComplete="new-password"
              />
              <label className="w-full relative">
                <input
                  type={type}
                  name="password"
                  id="password"
                  value={form.password}
                  onChange={handleChange}
                  placeholder="Choose a password"
                  className={`${fieldClass} pr-10`}
                  required
                  autoComplete='new-password'
                />
                <span 
                    onClick={handleToggle}
                    className="absolute inset-y-0 right-3 flex items-center cursor-pointer">
                    <Icon icon={icon} size={22} />
                </span>
              </label>
            </div>
            {error && (
                    <div className = "m-4">
                      {status === 'Error' && <p className="text-red-500 text-center"> Registration Failed </p>}
                      <p className="text-red-500 text-center"> {error}</p> 
                    </div>
                  )}
                         {status === 'Registered' ? (
               <RegistrationStatus 
                 email={form.email}
                 status="success"
                 onClose={handleClose}
               />
            ) : status === 'Pending Activation' ? (
                <ResendActivationLink/>
            ) : (
              <div className="flex flex-col text-center w-full">
                  <button
                        type="submit"
                        className={`${buttonClass} w-full justify-center`}
                      >
                        Register
                  </button>
                  <button
                      type="button"
                      onClick={handleCancel} // Close modal on click
                      className={`${buttonClass} w-full justify-center`}
                    >
                      Cancel
                  </button>        
              </div>
              
            ) }
            
            
          </form>

          <div className="text-center">
            <p className="text-sm text-gray-500">Already have an account? <span className="text-blue-600 cursor-pointer">Login</span></p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CandidateRegistration;
